import { render, staticRenderFns } from "./staffInfo.vue?vue&type=template&id=5e1b730c&"
import script from "./staffInfo.vue?vue&type=script&lang=js&"
export * from "./staffInfo.vue?vue&type=script&lang=js&"
import style0 from "./staffInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports